import axios from '@/services/axios.service';
import ERoutes from '@/services/endpoints.service';

const paymentMethodsAPI = {
  getPaymentMethods: async () => {
    return await axios.get(ERoutes.PAYMENT).then((response) => response.data);
  },

  postPaymentData: async (data) => {
    return await axios.post(ERoutes.PAYMENT, data);
  },
};

export const { getPaymentMethods, postPaymentData } = paymentMethodsAPI;
